module.exports = __webpack_public_path__ + "static/rf.548a44e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/rf.png
// module id = 452
// module chunks = 233698595820445